<div class="row d-md-flex ml-0 mr-0 position-relative" [ngClass]="marketingSlotTheme">
  <div *ngIf="marketingColumnSize==1">
    <pru-marketing-messages-one-column  [columnContent]="marketingSlotContent.columnWiseContent" [marketingTheme]="marketingSlotContent.colorTheme"  [retirementLink]="retirementLink"></pru-marketing-messages-one-column>
  </div>
  <div *ngIf="marketingColumnSize==2">
    <pru-marketing-messages-two-column  [columnContent]="marketingSlotContent.columnWiseContent" [marketingTheme]="marketingSlotContent.colorTheme" [contentId]="contentId"
    [retirementLink]="retirementLink"></pru-marketing-messages-two-column>
  </div>
  <div *ngIf="marketingColumnSize==3">
    <pru-marketing-messages-three-column  [columnContent]="marketingSlotContent.columnWiseContent" [marketingTheme]="marketingSlotContent.colorTheme"  [retirementLink]="retirementLink"></pru-marketing-messages-three-column>
  </div>
  <div *ngIf="htmlSlotStyle" [innerHTML]="style"></div>
</div>
